import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const updateImageProfile = createAsyncThunk(
  "profile/updateImageProfile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        "/api/user/updateImage",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data);
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        console.error("No response:", error.request);
        return rejectWithValue(error.request);
      } else {
        console.error("Error:", error.message);
        return rejectWithValue(error.message);
      }
    }
  }
);

const updateImageProfileSlice = createSlice({
  name: "updateImageProfile",
  initialState: {
    loadingForm: false,
    errorForm: null,
    successForm: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateImageProfile.pending, (state) => {
        state.loadingForm = true;
        state.errorForm = null;
        state.successForm = false;
      })
      .addCase(updateImageProfile.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.successForm = true;
      })
      .addCase(updateImageProfile.rejected, (state, action) => {
        state.loadingForm = false;
        state.errorForm = action.payload;
      });
  },
});

export default updateImageProfileSlice.reducer;
